import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroAmaxPayBatchPaymentForm.BillsInformation', {
    emptyText: 'No bills added to Batch Payment',
    selectBankAccount: 'Please select the bank account to use for the payment',
    addBankAccount: 'Add bank account',
    mergeBySupplier: 'Merge identical supplier bills into a single transaction',
    mergeBySupplierItemHeader: 'Bills from {contactName}',
    paymentDetailsChanged: 'Payment details have changed',
    learnMore: 'Learn more',
});

export const messagesConfig = defineMessages(
    'pages.RequestFormPage.XeroAmaxPayBatchPaymentForm.BillsInformation.tableConfig',
    {
        itemName: 'Bill name',
        billCurrency: 'Bill currency',
        paymentFee: 'Fee',
        paymentDetails: 'Payment details',
        paymentDetailsPlaceholder: 'Select payment details',
        addPaymentDetails: 'Add payment details',
        dateName: 'Date',
        dueDateName: 'Due date',
        amountDueName: 'Amount due',
        paymentReference: 'Ref.',
        paymentMethod: 'Payment method',
        paymentAmount: 'Payment amount',
        menuItemRemove: 'Remove',
        attachments: 'Attach',
    }
);
